export default __webpack_public_path__ + "static/media/MulherSegurandoCartao.349264ea.png";